import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

import { HandleDriversScreen, DriverUpdate, NewDriver } from '../screens/drivers';

const DriversRouter: FC = () => (
    <Routes>
        <Route path="/" element={<HandleDriversScreen />} />
        <Route path="new" element={<NewDriver />} />
        <Route path=":id" element={<DriverUpdate />} />
    </Routes>
);

export { DriversRouter };
